import { apiClient } from '@/api/client';

export type FeedbackCategory = 'bug' | 'idea' | 'praise' | 'other';
export type FeedbackSeverity = 'low' | 'med' | 'high' | 'blocker';

export interface FeedbackSubmitResponse {
  id: string;
  status: string;
  created_at: string;
}

export async function submitFeedback(
  payload: FormData,
  idempotencyKey: string
): Promise<FeedbackSubmitResponse> {
  const res = await apiClient.post<FeedbackSubmitResponse>('/feedback/', payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Idempotency-Key': idempotencyKey,
    },
  });
  return res.data;
}
